import { render, staticRenderFns } from "./CertificateDownload.vue?vue&type=template&id=a2570742"
import script from "./CertificateDownload.vue?vue&type=script&lang=js"
export * from "./CertificateDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports